import validator from 'validator';
import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};

  if (values.url && !/\S/.test(values.url)) {
    errors.url = i18n.t("Domain name is required");
  } else if (values.url && values.url.length < 3) {
    errors.url = i18n.t("Domain name must be longer than 3 characters");
  } else if (values.url && values.url.length > 128) {
    errors.url = i18n.t("Domain name must has no more than 128 characters");
  }
  if (values.url && !validator.isFQDN(values.url, { require_tld: true, allow_underscores: true, allow_trailing_dot: false })) {
    errors.url = i18n.t("Please enter a valid domain name");
  }

  return errors;
};

export default validate;
